import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export const roleApiKeyStore = {
  createRole: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_ROLE`],
    route: `/Role`,
    action: 'POST',
  }),
  updateRole: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_ROLE`],
    route: `/Role`,
    action: 'PUT',
  }),
  deleteRole: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_ROLE`, id],
    route: `/Role/${id}`,
    action: 'DELETE',
  }),
  getRoles: (): QueryKeyConfig => ({
    queryKey: [`GET_ROLES`],
    route: `/Role`,
  }),
  getRoleByID: (roleID?: number): QueryKeyConfig => ({
    queryKey: [`GET_ROLE_BY_ID`, roleID],
    route: `/Role/${roleID}`,
  }),
};
